import { BaseModel, convertToArrayModels, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import EmployerFilterOption from './EmployerFilterOption'

export type EmployerFilterType =
  | 'multiselect'
  | 'checkbox'
  | 'range'
  | 'sort'
  | 'selectedvalues'

export default class EmployerFilterGroup extends BaseModel {
  static override constructorName = 'EmployerFilterGroup'

  name: string = ''
  title: string = ''
  type: EmployerFilterType = 'multiselect'
  placeholder: string = ''
  items: EmployerFilterOption[] = []
  'range_min': number = 0
  'range_max': number = 0
  'range_step': number = 0

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    fillOwnProperties(this, data, ['items'])

    this.items = convertToArrayModels(data.items, EmployerFilterOption)
  }
}

registerModel(EmployerFilterGroup)
